<template>
  <div>
    <div class="wrapper">
      <b-row class="mt-2 mb-2">
        <b-col>
          <b-button class="pull-right" variant="primary" v-b-modal.create_project_introduction>Project introductie aanmaken</b-button>
        </b-col>
      </b-row>
      <div class="animated fadeIn">
        <resource-index header="Project introducties" endpoint="project-introductions" show-route="project-introductions.view" />
      </div>
    </div>
    <b-modal id="create_project_introduction" title="Project introductie aanmaken" hide-footer>
      <b-form @submit.prevent="createItem">
        <b-form-group label="Titel">
          <b-form-input type="text" required v-model="item.title"></b-form-input>
        </b-form-group>
        <hr>
        <b-button class="pull-left" variant="danger" @click="closeModal">Annuleer</b-button>
        <b-button type="submit" class="pull-right" variant="success">Maak project introductie aan</b-button>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import ResourceIndex from '../../components/ResourceIndex';
import {addData} from "@/api";

export default {
  name: 'project-introductions',
  components: { ResourceIndex },
  data() {
    return {
      item: {
        title: null
      },
    }
  },
  methods: {
    async createItem() {
      const request = await addData('project-introductions', {
        title: this.item.title
      }).then(response => response);

      if (request.status === 201) {
        return this.$router.push({ name: 'project-introductions.view', params: {id: request.data.data.id}});
      }
    },
    closeModal() {
      this.$bvModal.hide('create_project_introduction');
      this.item = {
        title: null,
      };
    }
  }
}

</script>
